import { render, staticRenderFns } from "./SecondaryChildNavItem.vue?vue&type=template&id=7c97fd79&scoped=true"
import script from "./SecondaryChildNavItem.vue?vue&type=script&lang=js"
export * from "./SecondaryChildNavItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryChildNavItem.vue?vue&type=style&index=0&id=7c97fd79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c97fd79",
  null
  
)

export default component.exports